import { Link, Teaser } from '@xprog/prensa'
import NextLink from 'next/link'
import first from 'lodash/first'
import get from 'lodash/get'
import React, { useEffect, useRef } from 'react'
import { Img } from 'react-image'
import { useImageProxy } from 'hooks/useImageProxy'
import useOnScreen from 'hooks/useOnScreen'
// import { enviarClickTeaser, enviarViewTeaser } from 'hooks/useGCJAnalytics'

const convertLocaleDate = (timestamp) => {
  const date = new Date(timestamp)
  const options: Intl.DateTimeFormatOptions = {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  }
  const dateString = date.toLocaleDateString('pt-BR', options)
  return dateString.replace(/(\d{4})(\s+\d{2}:\d{2})/, '$1 |$2')
}

const extractWidthFromImage = (teaserProps) => {
  const imageWidth = get(teaserProps, 'css[".TeaserImageContainer"].maxWidth', false)
  const imageWidthRegex = imageWidth ? imageWidth.match(/(\d+)/) : false
  const imageWidthParsed = imageWidthRegex && imageWidthRegex.length > 0 ? imageWidthRegex[1] : false
  const imageWidthFormatted = imageWidthParsed ? `&w=${Number(imageWidthParsed) * 2}` : false
  return imageWidthFormatted
}

const TeaserImageWrap = (teaserProps) => {
  const TeaserImageWrapComponent = (props) => {
    const imageWidthFormatted = extractWidthFromImage(teaserProps)
    const imageSrcUrl = useImageProxy(`${props?.url}${imageWidthFormatted || ''}`, true)

    if (!props?.url || imageSrcUrl === '') {
      return <></>
    }

    return (
      <Link
        bypass={false}
        href={teaserProps.path}
        css={{ fontSize: 0, width: '100%' }}
        onClick={(event) => {
          event.preventDefault()
          window.location.href = teaserProps.path
        }}
      >
        <Img alt={teaserProps.title} src={imageSrcUrl} unloader={<></>} loading={'lazy'} />
      </Link>
    )
  }
  TeaserImageWrapComponent.displayName = 'TeaserImageWrap'
  return TeaserImageWrapComponent
}

const RenderTeaser = (props) => {
  const { customLink, customLinkProps, local, teaserType, page,  ...otherCustomProps } = props?.customProps
  const ref = useRef(null);
  // const isVisible = useOnScreen(ref);

  //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
  // quando confirmado a migração, remover.
  // useEffect(() => {
  //   if(isVisible) {
  //     const pagina = page === undefined ? 0 : page;
  //     enviarViewTeaser(local, teaserType, pagina)
  //   }
  // }, [isVisible])

  const handleClickTeaser = () => {
    //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
    // quando confirmado a migração, remover.
    // const pagina = page === undefined ? 0 : page;
    // enviarClickTeaser(local, teaserType, pagina);
  }

  let subtitle = props?.subtitle
  if (props?.subtitleVariant === 'subtitle-datetime' && props.publishingTime) {
    subtitle = convertLocaleDate(props?.publishingTime)
  }

  let subject = props?.subject
  if (props?.subject === '') {
    subject = first(get(props, 'tags.tags', []))
  }
  let slotColor = props?.color || props?.slotColor
  return (
    <Teaser
      {...props}
      customLink={customLink || NextLink}
      customLinkProps={customLinkProps || { legacyBehavior: true }}
      customProps={{ onClick: handleClickTeaser, ref, ...otherCustomProps }}
      subtitle={subtitle}
      subject={subject}
      subjectColor={slotColor}
      wrapImage={TeaserImageWrap(props)}
    />
  )
}

export default RenderTeaser
